import Drawer from '@mui/material/Drawer'
import { themeColors } from '../../const/colors'
import styled from 'styled-components'
import { makeStyles } from '@mui/styles'

type Anchor = 'top' | 'left' | 'bottom' | 'right'
type Variant = 'persistent' | 'permanent' | 'temporary' | undefined

const useStyles = makeStyles({
  drawerPaper: {
    marginTop: '64px',
    overflowY: 'auto',
    height: `calc(100vh - 64px)`,
  },
})

const BaseDrawer = ({
  children,
  open,
  anchor = 'right',
  variant = 'persistent',
  width = 650,
  background = themeColors.lightBlue,
  disablePadding = false,
}: {
  children: any
  open: boolean
  anchor?: Anchor
  variant?: Variant
  width?: number
  background?: string
  disablePadding?: boolean
}) => {
  const classes = useStyles()
  return (
    <Drawer
      anchor={anchor}
      open={open}
      variant={variant}
      classes={{
        paper: classes.drawerPaper,
      }}
    >
      <DrawerContent
        data-e2e="drawer"
        $width={width}
        $background={background}
        $disablePadding={disablePadding}
      >
        {children}
      </DrawerContent>
    </Drawer>
  )
}

export default BaseDrawer

const DrawerContent = styled.div<{
  $width: number
  $background: string
  $disablePadding: boolean
}>`
  padding: ${({ $disablePadding }) => ($disablePadding ? '0' : '30px')};
  width: ${({ $width }) => `${$width}px`};
  max-width: 96vw;
  background-color: ${({ $background }) => $background};
  z-index: 1;
  display: flex;
  flex-direction: column;
  ${({ $disablePadding }) =>
    $disablePadding
      ? 'height: 100%; min-height: 0; overflow: hidden;'
      : 'flex: 1;'}
`
